<template>
    <v-container class="pt-0">
        <v-row>
            <v-col cols="12" class="pt-0 pb-3">
                <v-card class="mt-0 ">
                    <v-card-text>
                        <v-autocomplete
                            v-model="value_storehouse"
                            :items="storehouses"
                            dense
                            clearable 
                            clear-icon="far fa-times-circle"
                            label="Almacenes"
                            persistent-hint
                            :item-text="customText"
                            item-value="id"
                            hide-details
                            @change="handleSelecteStorehouse"
                            :filter="customFilter"
                        >
                            <template v-slot:item="data">
                                <v-list-item-content>
                                    <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                                    <v-list-item-subtitle v-if="!data.item.main">
                                        Repartidor: {{ data.item.deliveryman }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </template>
                        </v-autocomplete>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" class="pt-3 pb-3">
                <div class="list-storehouses wost-scroll pl-1 pr-1">
                    <v-card v-for="(storehouse, index) in storehouses" :key="storehouse.id" 
                        class="mt-3 " 
                        @click="handleViewDetailStorehouse(storehouse)"
                        :disabled="!verifyPermission('seleccionar_almacen_storehouse')">
                        <v-card-text class="padding-all-0">
                            <v-list two-line dense class="padding-top-0 padding-bootom-0 ">
                                <v-list-item>
                                    <v-list-item-avatar class="mr-2">
                                        <v-icon v-if="storehouse.main" :color="selectColor(index)">fas fa-warehouse</v-icon>
                                        <v-icon v-else :color="selectColor(index)">fas fa-truck</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <span class="order-customer-name">
                                                {{ storehouse.name | uppercase }}
                                            </span>
                                        </v-list-item-title>
                                        <v-list-item-subtitle v-if="!storehouse.main">
                                            <span class="order-status">
                                                Repartidor: {{ storehouse.deliveryman }}
                                            </span>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>                                
                                </v-list-item>
                            </v-list>
                        </v-card-text>
                    </v-card>
                </div>
            </v-col>            
        </v-row>
    </v-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
    name: 'ListStorehouses',
    data() {
        return {
            value_storehouse: '',
            color_selected: '#E53935',
            count_color: 0,
            colors: [
                '#E53935',
                '#43A047',
                '#1E88E5',
                '#5E35B1',
                '#C0CA33',
                '#F4511E',
                '#FFB300',
                '#6D4C41'
            ]
        }
    },
    computed: {
        ...mapState('storehouses', [
            'storehouses',
            'storehouseSelected'
        ]),
    },
    methods: {
        ...mapActions('storehouses', [
            'runSetStorehouses',
            'getStorehouses',
            'runSetStorehouseSelected',
            'selectStorehouseMain',
            'getProductsInStorehouse'
        ]),
        selectColor(index) {
            let indexColor = index
            if (index >= 8) {
                indexColor = index % 8
            }

            let color = this.colors[indexColor]

            return color
        },
        customText(item){
            let text = item.name
            
            return text
        },
        handleSelecteStorehouse(value){
            let storehouse_id = null            
            if(value !== undefined && value !== null){
                storehouse_id = value
            }
            this.searchStorehouse(null, storehouse_id)
        },
        customFilter(item, queryText, itemText) {
            const textName = item.name.toLowerCase()
            let textDeliveryman = ''
            if (item.deliveryman) {
                textDeliveryman = item.deliveryman.toLowerCase()
            }
            const searchText = queryText.toLowerCase()

            return textName.indexOf(searchText) > -1 || textDeliveryman.indexOf(searchText) > -1
        },
        searchStorehouse(type_customer = null, storehouse_id = null){
            let request = {
                params: {
                    storehouse_id: storehouse_id
                }
            }
            this.getStorehouses(request)
        },
        handleViewDetailStorehouse(storehouse) {
            this.runSetStorehouseSelected(storehouse)
            this.getProductsInStorehouse(this.storehouseSelected.id)
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        }
    },
    mounted() {
        this.getStorehouses()
        this.selectStorehouseMain()
        this.getProductsInStorehouse(this.storehouseSelected.id)
    }
}
</script>

<style>
.border-radius-10{
    border-radius: 10px !important;
}

.list-storehouses{
    height: 68vh;
    overflow-y: auto;
}
</style>